// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import Checkbox from '../core/checkbox';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withPermissions from '../../containers/with-permissions';
import withSearch from '../../containers/with-search';
import FormData from '../../containers/form-data';
import GenreSelect from '../app/genre-select';

const servicesDataKey = 'flaggedMetadata';
const formName = 'flaggedMetadataStatus';

function FlaggedMetadataItems(props) {
    const {hasAccessByRole, query, searchData, totalPages} = props;

    const removeRoviFields = ['tmsId'];
    const removeTmsFields = ['roviProgramId'];
    const filterByRoviFields = ['roviProgramId'];
    const filterByTmsFields = ['tmsId'];
    const sectionName = 'amsPrograms';

    const getColumnConfig = () => [
        {
            dataKey: 'amsPrograms.title',
            formatter: 'amsProgramTitle',
            link: '/investigation/flagged-metadata',
            linkKey: 'flaggedMetadataId',
            title: 'Title',
            type: 'link',
            width: '25%',
        },
        {
            dataKey: 'issues',
            formatter: 'issues',
            title: 'Flagged Fields',
            width: '15%',
        },
        {
            dataKey: 'lastUpdated',
            formatter: 'lastUpdated',
            title: 'Flag Updated',
            width: '20%',
        },
        {
            dataKey: 'amsPrograms.lastUpdate',
            formatter: 'amsProgramLastUpdate',
            title: 'AMS Updated',
            width: '20%',
        },
        {
            dataKey: 'inProgress',
            renderRowCallback: (dataRow, key) => renderCheckbox(dataRow, key, 'inProgress'),
            title: 'In Progress',
            type: 'checkbox',
            width: '10%',
        },
        {
            dataKey: 'fixed',
            renderRowCallback: (dataRow, key) => renderCheckbox(dataRow, key, 'fixed'),
            title: 'Fixed',
            type: 'checkbox',
            width: '10%',
        },
    ];

    const renderCheckbox = (dataRow, key, dataKey) => {
        const checkboxProps = {
            className: 'mass-action-table--checkbox',
            key,
            name: `${dataKey}[]`,
            value: get(dataRow, 'flaggedMetadataId', '').toString(),
            disabled: !hasAccessByRole({allowRoles: ['flaggedMetadata_update']}),
        };

        return <Checkbox {...checkboxProps} />;
    };

    const getPaginationProps = () => ({
        maxPages: 9,
        query,
        totalPages,
    });

    const getRowDetails = () => ({
        keyOrder: 'flaggedMetadata',
        blacklistKeys: ['amsPrograms.title', 'issues', 'version', 'dateCreated', 'createdBy'],
    });

    const getTablewithsortProps = () => ({
        ...props,
        columnConfig: getColumnConfig(),
        rowDetails: getRowDetails(),
        notSortable: ['issues', 'inProgress', 'fixed'],
        servicesDataKey,
    });

    const renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Title" name="amsPrograms.title" title="Use wildcard (*) for partial name match" />
            <Input label="Echostar ID" name="amsPrograms.echostarId" validate={['number']} />
            <Input label="Echostar3 ID" name="amsPrograms.echostarEventString" />
            <Select label="Status" name="status">
                <option value="">Filter by Status</option>
                <option value="OPEN">Open</option>
                <option value="IN_PROGRESS">In Progress</option>
                <option value="FIXED">Fixed</option>
            </Select>
            <GenreSelect className="with-form-field display-inline-block" />
            <Input label="Flagged Field" name="issues.fieldName" title="Use wildcard (*) for partial name match" />
            <Select label="Flag Type" name="issues.issueType">
                <option value="">Filter by Type</option>
                <option value="INVALID">Invalid</option>
                <option value="MISSING">Missing</option>
            </Select>
            <FormButtons />
        </ServicesSearchForm>
    );

    return (
        <FormData formName={formName}>
            {() => (
                <div className="flagged-metadata-items">
                    <ServicesExportPanelAction
                        extendedDownload={true}
                        filterByRoviFields={filterByRoviFields}
                        filterByTmsFields={filterByTmsFields}
                        removeRoviFields={removeRoviFields}
                        removeTmsFields={removeTmsFields}
                        searchData={searchData}
                        sectionName={sectionName}
                    />
                    <ServicesSearchPanelAction contentRenderer={renderForm} />
                    <SearchPagination {...getPaginationProps()} />
                    <SearchTableWithSort {...getTablewithsortProps()} />
                </div>
            )}
        </FormData>
    );
}

FlaggedMetadataItems.propTypes = {
    hasAccessByRole: PropTypes.func.isRequired,
    query: PropTypes.object,
    rowDetails: PropTypes.array,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withPermissions(withSearch(FlaggedMetadataItems, servicesDataKey));
